import React, { useState, useEffect } from "react";
import { css } from "@emotion/react";
import { CodeJar } from "codejar";
import { withLineNumbers } from "codejar/linenumbers";
import hljs from "highlight.js";
//import "highlight.js/styles/darcula.css"
import "highlight.js/styles/atom-one-dark.css";
import "highlight.js/styles/atom-one-light.css";
import { SplitPane } from "react-collapse-pane";
import TS from "typescript";

//codejar https://github.com/antonmedv/codejar https://codepen.io/antonmedv/pen/PoPoGwg

let jarHtml, jarCss, jarJs;

export default function CodePlayground(props) {
  const [url, setUrl] = useState(undefined);

  const codePlaygroundStyle = css`
    z-index: 2;
    width: 100%;
    height: 100%;
    .codejar-wrap {
      width: 100%;
      height: 100%;
      float: left;
    }
  `;

  const codePlaygroundOpenStyle = css`
    height: 100%;
  `;
  const codePlaygroundClosedStyle = css`
    height: 0px;
  `;

  const editorStyle = css`
    font-family: "Source Code Pro", monospace;
    font-size: 14px;
    font-weight: 400;
    letter-spacing: normal;
    line-height: 20px;
    padding: 10px;
    tab-size: 2;
    white-space: pre;
    width: 100%;
    height: 100%;
    resize: none !important;
  `;

  const titleBar = css`
    background-color: hsla(0, 0%, 0%, 0.04);
    padding-left: 5px;
  `;

  /*if (typeof window !== `undefined`) {
    debugger
    let jar = CodeJar(document.querySelector(".editor"), Prism.highlightElement)
  }*/
  useEffect(() => {
    const highlight = editor => {
      // highlight.js does not trims old tags,
      // let's do it by this hack.
      editor.textContent = editor.textContent;
      hljs.highlightElement(editor);
    };
    jarHtml = CodeJar(
      document.querySelector(".editor-html"),
      withLineNumbers(highlight),
      { window: window }
    );
    jarCss = CodeJar(
      document.querySelector(".editor-css"),
      withLineNumbers(highlight),
      { window: window }
    );
    jarJs = CodeJar(
      document.querySelector(".editor-js"),
      withLineNumbers(highlight),
      { window: window }
    );
    props.setCallEditorHtml(() => html => {
      jarHtml.updateCode(html);
      handleChange();
    });
    props.setCallEditorCss(() => css => {
      jarCss.updateCode(css);
      handleChange();
    });
    props.setCallEditorJs(() => js => {
      jarJs.updateCode(js);
      handleChange();
    });
    return () => {
      /*props.setEditorHtml(jarHtml.toString())
      props.setEditorCss(jarCss.toString())
      props.setEditorJs(jarJs.toString())*/
      props.setEditorHtml("");
      props.setEditorCss("");
      props.setEditorJs("");
    };
  }, []);

  useEffect(() => {
    jarHtml.toString() !== props.editorHtml &&
      jarHtml.updateCode(props.editorHtml);
    jarHtml.toString() !== props.editorCss &&
      jarCss.updateCode(props.editorCss);
    jarJs.toString() !== props.editorJs && jarJs.updateCode(props.editorJs);
    setUrl(
      getGeneratedPageURL({
        html: props.editorHtml,
        css: props.editorCss,
        js: props.editorJs,
      })
    );
  }, [props.editorHtml, props.editorCss, props.editorJs]);

  // https://dev.to/pulljosh/how-to-load-html-css-and-js-code-into-an-iframe-2blc
  const getGeneratedPageURL = ({ html, css, js }) => {
    const getBlobURL = (code, type) => {
      const blob = new Blob([code], { type });
      return URL.createObjectURL(blob);
    };

    const cssURL = getBlobURL(css, "text/css");
    const jsURL = getBlobURL(
      TS.transpile(js, {
        target: "es2020",
        strict: true,
        checkJs: true,
        noEmitOnError: true,
        typeCheck: true,
        allowJs: true,
        checkJs: true,
        strict: true,
      }),
      "text/javascript"
    );
    //console.log(TS.transpile(js));
    /*
    "compilerOptions": {
		"target": "es5",
		"module": "system",
		"moduleResolution": "node",
		"sourceMap": true,
		"typeCheck": true,
		"emitDecoratorMetadata": true,
		"experimentalDecorators": true,
		"removeComments": false,
		"noImplicitAny": true,
		"suppressImplicitAnyIndexErrors": true
	}*/
    let source = ``;
    const pos = html.indexOf("</head>");

    if (pos >= 0) {
      source = `${html.substr(0, pos)} ${
        css && `<link rel="stylesheet" type="text/css" href="${cssURL}" />`
      }
      ${js && `<script src="${jsURL}" defer></script>`} ${html.substr(pos)}`;
    } else {
      source = `
      <!DOCTYPE html>
      <html lang="de">
        <head>
          <meta charset="UTF-8" />
          <base href="https://uhahne.github.io/GIS/" />
          ${css && `<link rel="stylesheet" type="text/css" href="${cssURL}" />`}
          ${js && `<script src="${jsURL}" defer></script>`}
        </head>
        <body>
          ${html || ""}
        </body>
      </html>
    `;
    }
    return getBlobURL(source, "text/html");
  };

  function handleChange() {
    const html = jarHtml.toString(); //event.target.value
    const css = jarCss.toString();
    const js = jarJs.toString();
    //jar.updateCode(myHTML)
    setUrl(
      getGeneratedPageURL({
        html: html,
        css: css,
        js: js,
      })
    );
  }

  /*function handleChange() {
    props.setEditorHtml(jarHtml.toString())
    props.setEditorCss(jarCss.toString())
    props.setEditorJs(jarJs.toString())
  }*/

  return (
    <div
      css={[
        codePlaygroundStyle,
        props.codePlaygroundOpen
          ? codePlaygroundOpenStyle
          : codePlaygroundClosedStyle,
      ]}
    >
      <SplitPane
        split="vertical"
        collapseOptions={{
          beforeToggleButton: (
            <div css={props.collapseButtonStyle}>
              {String.fromCharCode(0x276f)}
            </div>
          ),
          afterToggleButton: (
            <div css={props.collapseButtonStyle}>
              {String.fromCharCode(0x276e)}
            </div>
          ),
          overlayCss: { backgroundColor: "black" },
          buttonTransition: "zoom",
          buttonPositionOffset: -20,
          collapsedSize: 30,
          collapseTransitionTimeout: 350,
          collapseDirection: "right",
        }}
      >
        <div css={codePlaygroundOpenStyle}>
          <div css={titleBar}>HTML</div>
          <div
            className="editor-html language-html"
            onInput={handleChange}
            css={editorStyle}
          ></div>
        </div>
        <div css={codePlaygroundOpenStyle}>
          <div css={titleBar}>CSS</div>
          <div
            className="editor-css language-css"
            onInput={handleChange}
            css={editorStyle}
          ></div>
        </div>
        <div css={codePlaygroundOpenStyle}>
          <div css={titleBar}>JavaScript</div>
          <div
            className="editor-js language-javascript"
            onInput={handleChange}
            css={editorStyle}
          ></div>
        </div>
        <div css={codePlaygroundOpenStyle}>
          <div css={titleBar}>Vorschau</div>
          {url !== "undefined" && (
            <iframe
              title="show code"
              allowFullScreen={true}
              sandbox="allow-scripts allow-same-origin allow-downloads allow-presentation allow-forms"
              src={url}
              css={css`
                width: 100%;
                height: 100%;
                margin: 0;
                border: none;
              `}
            />
          )}
        </div>
      </SplitPane>
    </div>
  );
}
